import React from "react";
import { SafeAreaView, View, Image } from "react-native";
import { useSelector } from "react-redux";
import * as CONSTS from "../../../assets/consts";
import Theme from "../../argon-ui/Theme";
import { getDir } from "../../util";

interface Props {
  isKioskMode?: boolean;
  children: any;
}
const LOGO_KIOSK = 250;
const LoginLayout = (props: Props) => {
  const { children } = props;
  const isKioskMode = useSelector((state: any) => state.AppReducer.isKioskMode);
  return (
    <SafeAreaView
      style={{
        flex: 1,
        flexDirection: "row",
        direction: getDir(),
      }}
    >
      {children}
      {/* === Cover in kiosk Mode === */}
      {isKioskMode && (
        <View
          style={{
            backgroundColor: Theme.COLORS.PRIMARY,
            flex: 1,
            width: "50%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={CONSTS.BRANDING?.LOGO_TYPE_WHITE}
            // width={LOGO_SIZE}
            // height={LOGO_SIZE}
            // style={styles.logo}
            style={{
              width: LOGO_KIOSK,
              height: 100,
              resizeMode: "contain",
            }}
          />
        </View>
      )}
    </SafeAreaView>
  );
};

export default LoginLayout;
